import React, { useState } from "react";
import { Col, Form, Input, Row, Select, Button } from "antd";

import { QueryParams, useAccoutContext } from "../provider";

import { GetProjectCenter, GetTenantSelects } from "../../../../../../services/dct/DctService";

import clsName from './index.module.scss'

const { Item } = Form;
const { Option } = Select

const colCols = {
  span: 6
}
const fieldCols = {
  labelCol: {
    span: 5
  },
  wrapperCol: {
    span: 19
  }
}

const auditOptions = [
  {label:'全部', value: ''},
  {label:'待审核', value: '1'},
  {label:'通过', value: '2'},
  {label:'未通过', value: '3'}
]

interface CenterRecord {
  name: string
  code: string
}
interface TenantRecord {
  name: string
  code: string
  selects: CenterRecord[]
}

// 排除特殊的筛选条件 startTime,endTime,projectList
interface ConditionParams extends Omit<QueryParams, 'projectList'> {
  projectCode: string
}

type ConditionParamsType = keyof Omit<QueryParams, 'projectList'>

const tenantMap: {[key: string]: CenterRecord[]} = {}

interface ConditionProps {

}
const Condition: React.FC<ConditionProps> = () => {

  const [ form ] = Form.useForm<ConditionParams>();

  const { setQueryParams } = useAccoutContext()

  const [tenantOptions, setTenantOptions] = useState<TenantRecord[]>([]);
  const [projectOptions, setProjectOptions] = useState<CenterRecord[]>([]);
  const [centerOptions, setCenterOptions] = useState<CenterRecord[]>([]);

  const handleFetchTenantData = async (open: boolean) => {
    if (tenantOptions.length > 0 || !open) {
      return
    }

    const { code, data }: {code: number, data: TenantRecord[]} = await GetTenantSelects()

    if (code === 0) {
      (data || []).map(item => {
        tenantMap[item.code] = item.selects;
      })
      setTenantOptions(data || [])
    }
  }

  const handleTenantChange = (value: string) => {
    form.setFieldsValue({
      projectCode: '',
      centerCode: '',
    })

    setProjectOptions(tenantMap[value] || [])
    setCenterOptions([])
  }

  const handleProjectChange = async (value: string) => {
    const { code, data } = await GetProjectCenter({
      projectCode: value
    })

    if (code === 0) {
      setCenterOptions(data || [])
    }

    form.setFieldsValue({
      centerCode: '',
    })
  }

  const handleSubmit = ({projectCode, ...params}: ConditionParams)=> {

    const queryParams: QueryParams = {}

    if (projectCode) {
      queryParams.projectList = [projectCode]
    }

    for(const name in params) {
      const key = name as ConditionParamsType
      if (params[key]) {
        queryParams[key] = params[key]
      }
    }

    setQueryParams(queryParams)
  }

  const handleClear = ()=> {
    setQueryParams({})
    form.resetFields()
  }

  return (
    <div className={clsName.wrapper}>
      <Form
        form={form}
        size='middle'
        onFinish={handleSubmit}
        initialValues={{
          auditState: "",
          tenantCode: "",
          projectCode: "",
          centerCode: "",
        }}
      >
        <Row gutter={8}>
          <Col {...colCols}>
            <Item {...fieldCols} name="subjectCode" label="任务编码">
              <Input placeholder="请输入任务编码"/>
            </Item>
          </Col>
          <Col {...colCols}>
            <Item {...fieldCols} name="createUser" label="上传人">
              <Input  placeholder="请输入上传人账号"/>
            </Item>
          </Col>
          <Col {...colCols}>
            <Item {...fieldCols} name="auditState" label="审核状态">
              <Select options={auditOptions} size='middle'/>
            </Item>
          </Col>
          <Col {...colCols}>
            <Button htmlType='submit' type="primary">搜索</Button>
            <Button onClick={handleClear} style={{marginLeft: 10}}>重置</Button>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col {...colCols}>
            <Item {...fieldCols} name="tenantCode" label="租户">
              <Select onChange={handleTenantChange} onDropdownVisibleChange={handleFetchTenantData}>
                <Option value="">全部</Option>
                {
                  tenantOptions.map(({ code, name }) => (
                    <Option key={code} value={code}>{name}</Option>
                  ))
                }
              </Select>
            </Item>
          </Col>
          <Col {...colCols}>
            <Item {...fieldCols} name="projectCode" label="项目中心">
              <Select disabled={projectOptions.length === 0} onChange={handleProjectChange}>
                  <Option value="">全部</Option>
                  {
                    projectOptions.map(({ code, name }) => (
                      <Option key={code} value={code}>{name}</Option>
                    ))
                  }
                </Select>
            </Item>
          </Col>
          <Col {...colCols}>
            <Item {...fieldCols} name="centerCode" label="所属中心">
              <Select placeholder="请选择所属中心" disabled={centerOptions.length === 0}>
                <Option value="">全部</Option>
                {
                  centerOptions.map(({ code, name }) => (
                    <Option key={code} value={code}>{name}</Option>
                  ))
                }
              </Select>
            </Item>
          </Col>
          <Col {...colCols}/>
        </Row>
      </Form>
    </div>
  );
};

export default Condition;
